import React from "react"
import { Box, BoxProps, Tabs, TabsProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { ScrollableIconButton } from "./ScrollableIconButton"

export interface IScrollableTabProps
  extends Pick<TabsProps, "orientation" | "children" | "onChange" | "value">,
    Omit<BoxProps, "children" | "onChange" | "component"> {
  tabsProps?: Omit<TabsProps, "children" | "orientation">
}

export const ScrollableTab: React.FC<IScrollableTabProps> = ({
  children,
  sx = {},
  tabsProps = {},
  orientation = "horizontal",
  value = 0,
  onChange: onChangeProp = (event, newValue) => {},
  ...props
}) => {
  const theme = useTheme()
  const { root, scrollContainer } =
    theme.components[`ScrollableTab`]?.styleOverrides || {}

  return (
    <Box sx={deepmerge(root, sx)} {...props}>
      <Tabs
        value={value}
        onChange={onChangeProp}
        variant="scrollable"
        scrollButtons
        orientation={orientation}
        allowScrollButtonsMobile
        sx={scrollContainer}
        ScrollButtonComponent={ScrollableIconButton}
        {...tabsProps}
      >
        {children}
      </Tabs>
    </Box>
  )
}
